/* eslint-disable */

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
// Styles
import styled from "styled-components";
// Helpers
import Slider from "react-slick";
// Components
import Loading from "./Loading";
import {
  Text,
  Triangle,
  Link,
  TextTruncate,
  ScreenReaderText,
  Icon,
  Picture
} from "../../atoms";
import {
  Section,
  PlusButton,
  CustomArrow,
  ContentContainerMolecule
} from "../../molecules";

function Header({ className, isLoading, styles, data }) {
  const [onEdgeLeft, setEdgeLeft] = useState(false);
  const [onEdgeRight, setEdgeRight] = useState(false);
  const sliderRef = useRef(null);

  const onHandleTabNavigation = e => {
    if (e.key === "Tab" && e.shiftKey) {
      sliderRef.current.slickPrev();
    }

    if (e.key === "Tab") {
      sliderRef.current.slickNext();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 0);
  }, [window.innerWidth]);

  const onMouseMove = e => {
    setEdgeLeft(e.pageX <= 80);
    setEdgeRight(e.pageX >= window.innerWidth - 80);
  };

  const onEdgeClass = onEdgeLeft
    ? "onEdgeLeftArrow"
    : onEdgeRight && "onEdgeRightArrow";

  const scrollHeight = window.innerHeight - 80;

  const scrollDown = () => {
    window.scrollTo({
      top: scrollHeight,
      left: 0,
      behavior: "smooth"
    });
  };

  const onHandleEnter = (e, url) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      window.open(url, "_blank");
    }
  };

  return (
    <section className={className}>
      <ScreenReaderText>
        <Text as="h2" text="Destaques Institucionais" />
      </ScreenReaderText>
      {isLoading ? (
        <Loading />
      ) : (
        <Slider
          ref={sliderRef}
          useTransform={false}
          slidesToShow={1}
          slidesToScroll={1}
          speed={500}
          dots={false}
          arrows
          className={onEdgeClass}
          infinite={false}
          accessibility
          prevArrow={
            <CustomArrow color="#fff" ariaLabel="slide anterior" left darken />
          }
          nextArrow={
            <CustomArrow color="#fff" ariaLabel="próximo slide" darken />
          }
        >
          {data.list.map((item, index) => (
            <ContentContainerMolecule
              key={index}
              position="relative"
              onKeyDown={onHandleTabNavigation}
              onKeyPress={e => onHandleEnter(e, item.url)}
            >
              <div tabIndex={0} className="header-navigate">
                <Picture
                  className="header-image"
                  src={item.image.url}
                  aria-label={`Imagem do Destaque ${item.image.alt}`}
                  alt={`Imagem do Destaque ${item.image.alt}`}
                  hasEndpoint={false}
                  onMouseMove={onMouseMove}
                  endpoint={() => null}
                  isVector={false}
                  isLocal={item.image.isLocal}
                  size="lg"
                  useHeight
                />
                <Section
                  backgroundColor={styles.backgroundColor}
                  paddingTop="20px"
                  paddingBottom="20px"
                  mdPaddingTop="20px"
                  position="absolute"
                  width="100%"
                  bottom="0"
                  height="109px"
                >
                  <div className="container container-text">
                    <div className="row align-items-center container-text-row">
                      <PlusButton
                        position="absolute"
                        backgroundColor="transparent"
                        size="60px"
                        XsSize="40px"
                        alignItems="start"
                        top="-50px"
                        right="25px"
                        zIndex="2"
                        aria-hidden="true"
                        aria-label="botão mais"
                        tabIndex={-1}
                        href={item.url}
                        target="_blank"
                      >
                        <Text
                          fontSize="50px"
                          mobileXsFontSize="40px"
                          fontWeight="100"
                          color={styles.textColor}
                          fontDecoration="none"
                          transform="rotate(45deg)"
                          margin="auto"
                          target="_blank"
                          aria-hidden="true"
                          tabIndex={-1}
                          text="+"
                          lineHeight="0"
                        />
                      </PlusButton>
                      <Triangle
                        color={styles.backgroundColor}
                        size="40px"
                        top="-60px"
                        right="15px"
                        XsSize="30px"
                        XsTop="-50px"
                      />
                      <div className="col-12">
                        <TextTruncate>
                          <Text
                            text={item.description}
                            color={styles.textColor}
                          />
                        </TextTruncate>
                      </div>
                      <div className="col-12">
                        <Text as="h3">
                          <Link
                            tabIndex={-1}
                            fontSize="32px"
                            fontWeight="500"
                            text={item.title}
                            display="block"
                            color={styles.textColor}
                            target="_blank"
                            lineHeight="1.5"
                            href={item.url}
                            fontDecoration="none"
                          />
                        </Text>
                      </div>
                    </div>
                    <div className="scroll-more">
                      <button
                        tabIndex={-1}
                        onClick={scrollDown}
                        aria-label="Sroll para baixo"
                      >
                        <Icon
                          name="fal fa-chevron-down"
                          color={styles.textColor}
                        />
                      </button>
                    </div>
                  </div>
                </Section>
              </div>
            </ContentContainerMolecule>
          ))}
        </Slider>
      )}
    </section>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.string,
  data: PropTypes.object.isRequired,
  styles: PropTypes.object
};

Header.defaultProps = {
  data: {},
  isLoading: false,
  styles: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    textColor: "#fff"
  }
};

const HeaderWithStyles = styled(Header)`
  .header-navigate {
    :focus {
      outline: 2px solid inherit;
      outline-offset: -2px;
    }
  }
  //To Remove Space, slick-slider needs same height as image
  .slick-slider,
  .slick-track,
  .header-image,
  .header-image img {
    max-height: 992px;
    height: calc(100vh - 145px);
  }

  .slick-slider {
    overflow-y: hidden;
    &:hover {
      .slick-next,
      .slick-prev {
        background-color: rgba(0, 0, 0, 0.2);
        i {
          color: #fff;
          width: auto;
          height: auto;
          line-height: 80px;
          text-align: center;
        }
      }
    }
  }

  /*Scrool more*/
  .scroll-more {
    height: 20px;
    width: 100%;
    text-align: center;
    position: relative;
    bottom: -10px;
    button {
      background-color: transparent;
      height: 24px;
      width: 24px;
      border: none;
      transition: ease 1s;
      -webkit-animation: bouncey 1.6s linear infinite;
      animation: bouncey 1.6s linear infinite;
    }
  }

  @keyframes bouncey {
    0% {
      transform: translateY(0);
      -webkit-transform: translateY(0);
      -moz-transform: translateY(0);
    }
    50% {
      transform: translateY(4px);
      -webkit-transform: translateY(4px);
      -moz-transform: translateY(4px);
    }
    100% {
      transform: translateY(0);
      -webkit-transform: translateY(0);
      -moz-transform: translateY(0);
    }
  }

  .slick-slide {
    height: inherit;
  }

  .slick-slide img {
    object-fit: cover;
    object-position: center center;
    width: 100%;
  }

  /* Medium devices (tablets, less than 992px)*/
  @media (max-width: 991px) {
    .slick-slider,
    .slick-track,
    .header-image,
    .header-image img {
      height: calc(100vh - 125px);
    }
  }

  .onEdgeRightArrow > .slick-next,
  .onEdgeLeftArrow > .slick-prev {
    i {
      color: #fff;
    }
    background-color: rgba(0, 0, 0, 0.3);
  }

  .slick-next,
  .slick-prev {
    width: 80px;
    height: 80px;
    top: calc(50% - 80px);
    background-color: transparent;

    :hover {
      background-color: rgba(0, 0, 0, 0.25);
    }
    :focus {
      i {
        color: #fff;
      }
      background-color: rgba(0, 0, 0, 0.3);
    }

    i {
      color: transparent;
      width: auto;
      height: auto;
      line-height: 80px;
      text-align: center;
    }
  }

  .slick-prev {
    left: 0;
  }

  .slick-next {
    right: 0;
  }

  .slick-next:before,
  .slick-prev:before {
    content: none;
  }

  //For the button
  .container-text {
    position: relative;
    .container-text-row {
      min-height: calc(109px - 40px);
    }
  }
`;

export default HeaderWithStyles;
